import React from 'react';
import styled from 'styled-components';
const Wrapper = styled.div`
  background-color: ${({theme}) => theme.secondaryColor};
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: scroll;
`;
const Container = styled.div`
  width: 1200px;
  max-width: 100%;
  padding: 15px;
  margin: 0 auto;
`;

const DataPrivacy = () => {
  return (
    <Wrapper>
      <Container>
        <a href='/'>Zurück</a>
        <h1 id='heading__Datenschutzerklaerung_'>Datenschutzerklärung</h1>
        <p>
          Der Schutz Ihrer persönlichen Daten ist uns ein besonderes Anliegen. Wir verarbeiten Ihre Daten daher
          ausschließlich auf Grundlage der gesetzlichen Bestimmungen (DSGVO, TKG 2003). In diesen
          Datenschutzinformationen informieren wir Sie über die wichtigsten Aspekte der Datenverarbeitung im Rahmen
          unserer Website.
        </p>
        <p>
          Besuch unserer Webseite wird Ihre IP-Adresse, Beginn und Ende der Sitzung für die Dauer dieser Sitzung
          erfasst. Dies ist technisch bedingt und stellt damit ein berechtigtes Interesse iSv Art 6 Abs 1 lit f DSGVO
          dar. Soweit im Folgenden nichts anderes geregelt wird, werden diese Daten von uns nicht weiterverarbeitet.
        </p>
        <h2>Kontakt mit uns</h2>
        <p>
          Wenn Sie per Formular auf der Website oder per E-Mail Kontakt mit uns aufnehmen, werden Ihre angegebenen Daten
          zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen sechs Monate bei uns gespeichert. Diese
          Daten geben wir nicht ohne Ihre Einwilligung weiter.
        </p>
        <h2>Cookies</h2>
        <p>
          Unsere Website verwendet so genannte Cookies. Dabei handelt es sich um kleine Textdateien, die mit Hilfe des
          Browsers auf Ihrem Endgerät abgelegt werden. Sie richten keinen Schaden an.{' '}
        </p>
        <p>
          Wir nutzen Cookies dazu, unser Angebot nutzerfreundlich zu gestalten. Einige Cookies bleiben auf Ihrem
          Endgerät gespeichert, bis Sie diese löschen. Sie ermöglichen es uns, Ihren Browser beim nächsten Besuch
          wiederzuerkennen.
        </p>
        <p>
          Wenn Sie dies nicht wünschen, so können Sie Ihren Browser so einrichten, dass er Sie über das Setzen von
          Cookies informiert und Sie dies nur im Einzelfall erlauben.
        </p>
        <p>Bei der Deaktivierung von Cookies kann die Funktionalität unserer Website eingeschränkt sein.</p>
        <p>
          Folgende Cookies werden eingesetzt:
          <ul>
            <li>accept_cookies</li>
            <li>_gat (Google analytics)</li>
            <li>_gid (Google analytics)</li>
            <li>_ga (Google analytics)</li>
          </ul>
        </p>
        <h2>Web-Analyse</h2>
        <p>
          Unsere Website verwendet Funktionen des Webanalysedienstes
          <i>
            <em>Google Inc.</em> (1600 Amphitheatre Parkway, Mountain View, CA 94043, United States) betrieben und
            bereitgestellt wird.
          </i>
          Dazu werden Cookies verwendet, die eine Analyse der Benutzung der Website durch Ihre Benutzer ermöglicht. Die
          dadurch erzeugten Informationen werden auf den Server des Anbieters übertragen und dort gespeichert.{' '}
        </p>
        <p>
          Sie können dies verhindern, indem Sie Ihren Browser so einrichten, dass keine Cookies gespeichert werden.{' '}
        </p>
        <p>Wir haben mit dem Anbieter einen entsprechenden Vertrag zur Auftragsdatenverarbeitung abgeschlossen.</p>
        <p>
          Ihre IP-Adresse wird erfasst, aber umgehend (z.B. durch Löschung der letzten 8 Bit)pseudonymisiert. Dadurch
          ist nur mehr eine grobe Lokalisierung möglich.
        </p>
        <p>
          Die Datenverarbeitung erfolgt auf Basis der gesetzlichen Bestimmungen des § 96 Abs 3 TKG sowie des Art 6 Abs 1
          lit a (Einwilligung) und/oder f (berechtigtes Interesse) der DSGVO.
        </p>
        <p>
          Unser Anliegen im Sinne der DSGVO (berechtigtes Interesse) ist die Verbesserung unseres Angebotes und unseres
          Webauftritts. Da uns die Privatsphäre unserer Nutzer wichtig ist, werden die Nutzerdaten pseudonymisiert.
        </p>
        <p>Die Nutzerdaten werden für die Dauer von 26 Monaten aufbewahrt.</p>
        <h2>Ihre Rechte</h2>
        <p>
          Ihnen stehen bezüglich Ihrer bei uns gespeicherten Daten&nbsp;grundsätzlich die Rechte auf Auskunft,
          Berichtigung, Löschung, Einschränkung, Datenübertragbarkeit, Widerruf und Widerspruch zu. Wenn Sie glauben,
          dass die Verarbeitung Ihrer Daten gegen das Datenschutzrecht verstößt oder Ihre datenschutzrechtlichen
          Ansprüche sonst in einer Weise verletzt worden sind, können Sie sich bei uns tischler@wko.at oder der
          Datenschutzbehörde beschweren.
        </p>
        <h2>Sie erreichen uns unter folgenden Kontaktdaten:</h2>
        Bundesinnung der Tischler und Holzgestalter
        <br />
        Wirtschaftskammer Österreich
        <br />
        Wiedner Hauptstraße 63 | 1045 Wien
        <br />
        <span>T</span> 05 90 900-3234 | <span>F</span> 05 90 900-113234
        <br />
        <span>E</span> tischler@wko.at | <span>W</span> www.tischler.at
        <br />
      </Container>
    </Wrapper>
  );
};
export default DataPrivacy;



// WEBPACK FOOTER //
// ./src/components/DataPrivacy.js